import React from 'react';
import { formatVsPar } from '../utils/pingolfScoring';
import './PinGolfScore.css';

// One place that decides how a PinGolf score reads. Every board (event leaderboard, weekly
// net board, TV board, the player's own scorecard) was formatting and coloring its own cells,
// so "under par is green" was true in three files and half-true in a fourth. Anything that
// renders a vs-par number goes through here.
//
// Lower is better in PinGolf, so under par (negative) is green and over par (positive) is red -
// the opposite of the usual "negative number is bad" reading, which is exactly why it needs to
// be obvious at a glance. Doubling the target is circled, the way golf circles a good hole.
export function pingolfScoreTone(value) {
  const numeric = Number(value);
  if (value === null || value === undefined || value === '' || !Number.isFinite(numeric)) return 'none';
  if (numeric < 0) return 'under';
  if (numeric > 0) return 'over';
  return 'even';
}

function PinGolfScore({
  value,
  doubled = false,
  emphasis = false,
  placeholder = '-',
  title,
  className = ''
}) {
  const tone = pingolfScoreTone(value);
  const text = tone === 'none' ? placeholder : formatVsPar(Number(value));
  const isDoubled = Boolean(doubled) && tone !== 'none';

  const classes = [
    'pg-score',
    `pg-score-${tone}`,
    isDoubled ? 'is-doubled' : '',
    emphasis ? 'is-emphasis' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} title={title || (isDoubled ? 'Doubled the target' : undefined)}>
      {text}
      {isDoubled && <span className="pg-score-sr">(doubled the target)</span>}
    </span>
  );
}

// The color and the circle only work if the board says once what they mean. Any page showing
// scored holes should render this near the table.
export function PinGolfScoreLegend({ className = '' }) {
  return (
    <p className={`pg-score-legend ${className}`.trim()}>
      <PinGolfScore value={-1} /> under par (good)
      <span className="pg-score-legend-sep" aria-hidden="true">·</span>
      <PinGolfScore value={1} /> over par
      <span className="pg-score-legend-sep" aria-hidden="true">·</span>
      <PinGolfScore value={-3} doubled /> doubled the target
    </p>
  );
}

export default PinGolfScore;
